import { IVillageDictionary } from '@/dictionaries/pages/village/types';
import { VillageTranslation } from '@/services/types';
import { cn } from '@/lib/utils';
import { formatRichText } from '@/utils/rich-text';

type Props = {
  translations: VillageTranslation;
  villageDict: IVillageDictionary;
};

// Both rule columns share the same typography, so a paragraph reads the same no matter
// which side it lands on. The horizontal padding is the gutter between them.
const RULES_COLUMN_CLASS =
  'leading-[1.6] w-full flex-[0_0_auto] [&>p]:mb-4 [&>p:last-child]:mb-0 desktop:w-1/2';

export default function MustKnowContent({ translations, villageDict }: Props) {
  const { mustKnow } = villageDict;
  const rules = formatRichText(translations['rules']);

  const notes = formatRichText(translations['notes']);

  return (
    <div>
      <div className="mb-[40px]">
        <span className="inline-block mb-[10px] text-xl font-semibold">
          {mustKnow.villageRules}
        </span>
        <div className="flex flex-row flex-wrap">
          {translations.splittedRules ? (
            <>
              <div
                className={cn(RULES_COLUMN_CLASS, 'desktop:pr-8')}
                dangerouslySetInnerHTML={{
                  __html: formatRichText(translations.splittedRules[0]),
                }}
              />
              <div
                className={cn(RULES_COLUMN_CLASS, 'desktop:pl-8')}
                dangerouslySetInnerHTML={{
                  __html: formatRichText(translations.splittedRules[1]),
                }}
              />
            </>
          ) : (
            <div
              className="leading-[1.6] pr-4 w-full flex-[0_0_auto] [&>p]:mb-4 [&>p:last-child]:mb-0"
              dangerouslySetInnerHTML={{ __html: rules }}
            />
          )}
        </div>
      </div>
      <div className="mb-[40px]">
        <span className="inline-block mb-[10px] text-xl font-semibold">
          {mustKnow.notes}
        </span>
        <div>
          <div
            className="leading-[1.6] [&>p]:mb-4 [&>p:last-child]:mb-0"
            dangerouslySetInnerHTML={{ __html: notes }}
          />
        </div>
      </div>
    </div>
  );
}
